import axios from "axios";
import { server, port } from "./environment";
import VueCookies from "vue-cookies";
export default () => {
  const token = $cookies.get("token")
  const isHttps = typeof server === 'string' && server.startsWith('https://')
  const isHttp = typeof server === 'string' && server.startsWith('http://')
  const isDefaultPort = (isHttps && (port === 443 || port === 80)) || (isHttp && port === 80)
  const baseURL = (port && !isDefaultPort) ? `${server}:${port}/api/` : `${server}/api/`
  return axios.create({
    baseURL,
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: "Bearer " + token } : {})
    }
  });
};
